import React, { useState } from "react";
import { Modal, Button, Image} from "react-bootstrap";
import warningIcon from "../assets/images/caution-image.png";

function WarningModal() {
  const [showModal, setShowModal] = useState(true);

  const handleHide = () => {
    setShowModal(false);
  };

  return (
    <React.Fragment>
      <Modal show={showModal} size={"lg"}>
        <Modal.Header className="d-flex flex-column align-items-center justify-content-center">
          <div>
            <Image src={warningIcon} />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="justify-content-center text-center">
            <h2 className="text-size-sub-headline-2 text-error">PERINGATAN!</h2>
            <div className="mt-2 text-primary text-size-sub-body-2">
              HATI-HATI, Transaksi ini berisiko tinggi. Anda dapat saja
              mengalami kerugian atau kehilangan uang. Jangan berutang jika
              tidak memiliki kemampuan membayar. Pertimbangkan secara bijak
              sebelum bertransaksi.
            </div>
            <div className="mt-5 fw-bold text-primary text-size-sub-body-2">
              PENGUMUMAN
            </div>
            <div className="mt-2  text-primary text-size-sub-body-2">
              Pohondana merupakan <strong>entitas yang berdiri sendiri</strong> dan <strong>tidak terafiliasi </strong>
              dengan aplikasi  dompet digital<strong> DANA.</strong>
            </div>  
            <div className="my-4">
              <Button variant="primary" size="lg" onClick={handleHide}>
                Saya Mengerti
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default WarningModal;
